export const isSmall = () => window.innerWidth <= 744
export const isMedium = () => window.innerWidth <= 1128
export const isLargeOnly = () => !isMedium()
export const bestImageRatio = (imageName, extension = 'png') =>
  `${imageName}${window.devicePixelRatio > 1 ? '@2x' : ''}.${extension}`
